import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SnackbarComponent } from './snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  private snackbarSubject = new Subject<any>();
  public snackbarState = this.snackbarSubject.asObservable();

  showErrorSnackBar(message:string) {
    this.snackbarSubject.next({
      showSnackbar: true,
      message: message,
      type: 'error'
    });
  }
  showSuccessSnackBar(message:string) {
    this.snackbarSubject.next({
      showSnackbar: true,
      message: message,
      type: 'success'
    });
  }

  showWarningSnackBar(message:string) {
    this.snackbarSubject.next({
      showSnackbar: true,
      message: message,
      type: 'warning'
    });
  }
  
  showAlertInfoSnackBar(message:string) {
    this.snackbarSubject.next({
      showSnackbar: true,
      message: message,
      type: 'info-warning'
    });
  }

  showInfoSnackBar(message:string) {
    this.snackbarSubject.next({
      showSnackbar: true,
      message: message,
      type: 'information'
    });
  }


}
